import { Injectable } from '@angular/core';
import {CreateModalService} from './createModal.service';

@Injectable({
  providedIn: 'root'
})
export class CrudModalService extends CreateModalService{
}
